import { useEffect, useRef } from "react";

const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_portfolio-showcase-2301/artifacts/c4d5v9cd_%E1%84%8E%E1%85%A5%E1%86%BA%E1%84%91%E1%85%A6%E1%84%8B%E1%85%B5%E1%84%8C%E1%85%B5.png";

export default function Hero() {
  const sectionRef = useRef(null);

  /* Subtle mouse parallax — pushes a translate via CSS variables on the section. */
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    let raf = 0;
    let tx = 0,
      ty = 0,
      cx = 0,
      cy = 0;

    const onMove = (e) => {
      const r = el.getBoundingClientRect();
      tx = (e.clientX - r.left) / r.width - 0.5;
      ty = (e.clientY - r.top) / r.height - 0.5;
    };
    const tick = () => {
      cx += (tx - cx) * 0.08;
      cy += (ty - cy) * 0.08;
      el.style.setProperty("--mx", cx.toFixed(4));
      el.style.setProperty("--my", cy.toFixed(4));
      raf = requestAnimationFrame(tick);
    };
    window.addEventListener("mousemove", onMove);
    raf = requestAnimationFrame(tick);
    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <section
      id="top"
      ref={sectionRef}
      data-testid="hero-section"
      className="relative min-h-screen w-full bg-[#f6f3ed] text-black overflow-hidden"
    >
      {/* Full-screen editorial hero image (already contains the Mia Cho brand label) */}
      <div className="absolute inset-0 hero-enter hero-enter-1">
        <div className="absolute inset-0 parallax-soft">
          <img
            src={HERO_IMAGE}
            alt="Mia Cho — 99% Flower, 1% Chaos collection lineup"
            loading="eager"
            data-testid="hero-image"
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>
      </div>
    </section>
  );
}
